import React from "react";
import { ImageIcon } from "lucide-react";
type MockupSlotProps = {
  src?: string;
  label: string;
  hint?: string;
  className?: string;
};
export function MockupSlot({
  src,
  label,
  hint = "Emplacement réservé au visuel réel",
  className = ""
}: MockupSlotProps) {
  if (src) {
    return <div className={`overflow-hidden rounded-2xl bg-paper ${className}`} data-id="element-118" data-mp="3hwajgtshs66v">
        <img src={src} alt={label} className="h-full w-full object-cover" data-id="element-119" data-mp="9hjqqe06sh1i" />
      </div>;
  }
  return <div role="img" aria-label={`${label} — visuel à venir`} className={`flex flex-col items-center justify-center gap-2 rounded-2xl border-2 border-dashed border-ink/20 bg-paper/70 p-4 text-center ${className}`} data-id="element-120" data-mp="egwp9w0f7cjx">
      <ImageIcon className="h-6 w-6 text-ink-soft/70" aria-hidden="true" data-id="element-121" data-mp="4gm9c3n03r12" />
      <p className="font-display text-sm font-semibold text-ink md:text-base" data-id="element-122" data-mp="2k91z5248936g">
        {label}
      </p>
      <p className="text-xs text-ink-soft" data-id="element-123" data-mp="2p9hc3sklk8nw">{hint}</p>
    </div>;
}